<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="classId"
            :search-url="searchUrl"
            create-url=""
            delete-url=""
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :accept-edit="false"
            :acceptView="false"
            :accept-create="false"
            :accept-back="5001"

        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants, cateContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/class/ClassCreate";
import {classIsActive} from "@/constants/cateContants";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Thông tin chi tiết lớp học",
      formCreateName: "Thêm mới lớp học",
      category: null,
      lastSearchValues: {},
      visibleCreateDialog: false,
      searchUrl: null,
      timeReload: 0,
      hiddenFields: {
        typeId: "0",
      },
      fields: [

        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center",
        },
        {
          value: 'classId',
          text: 'Tên lớp',
          width: "20%",
          sortable: false,
          headerStyle: "text-align:center",
          type: "select",
          name: "classId",
          items: [],
          itemText: "className",
          itemValue: "classId",
        },
        {
          value: 'levelId',
          text: 'Tên level',
          width: "20%",
          sortable: false,
          headerStyle: "text-align:center",
          type: "select",
          name: "levelId",
          search: true,
          items: [],
          itemText: "levelName",
          itemValue: "levelId",
        },
        {
          value: 'weekNo',
          text: 'Tuần số',
          sortable: false,
          search: true,
          width: "10%",
          headerStyle: "text-align:center",
        },
        {
          value: 'unitOrder',
          text: 'Unit số',
          sortable: false,
          search: true,
          width: "10%",
          headerStyle: "text-align:center",
        },
        {
          value: 'unitId',
          text: 'Tên unit',
          width: "20%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "unitId",
          items: [],
          itemText: "unitName",
          itemValue: "unitId",
        },

        {
          value: 'startDate',
          text: 'Ngày bắt đầu',
          sortable: false,
          search: true,
          width: "10%",
          dateFormat: 'dd/MM/yyyy',
          headerStyle: "text-align:center",
          //type: "datepicker"
        },
        {
          value: 'endDate',
          text: 'Ngày kết thúc',
          sortable: false,
          search: true,
          width: "10%",
          dateFormat: 'dd/MM/yyyy',
          headerStyle: "text-align:center",
          //type: "datepicker"
        },
      ],
    };
  },

  created() {
    this.searchUrl ="/babiClassWeek/search/" + this.$route.params.id + "?sortField=status,classId&";

    axios.post(
        process.env.VUE_APP_API_URL + "/babiClass/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "classId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/babiLevel/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "levelId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/babiUnit/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "unitId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
  },

  methods: {
    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới lớp học';
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật lớp học';
        this.visibleCreateDialog = true;
      }
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/babiClass/view/' + item.classId, query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
